<template>
  <div class="base-toggle-buttons" :class="{ 'is-selected': item.selected }">
    <BaseIcon class="base-toggle-buttons__icon" :name="item.icon" />
    <slot>Text</slot>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'BaseToggleButtons',
  components: {
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
    },
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.base-toggle-buttons {
  color: grey;
  align-items: center;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  padding: 2px 6px;
  border-radius: $border-radius-small;
  gap: 8px;
  width: max-content;
  cursor: pointer;
  background-color: $color-text-annotation;
  transition: 200ms;

  &__icon {
    &.base-icon {
      width: 12px;
      height: 12px;
    }
  }

  &.is-selected {
    background-color: rgba($color-text-annotation-hover, 0.75);
    color: $color-normal;
  }

  &:hover {
    background-color: $color-text-annotation-hover;
  }
}
</style>
